import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { testTypeFields } from "../../stories/Forms/fields";
import DynamicForm from "../../stories/Forms/DynamicForm";
import useApis from "../../services/useAPI";
import { confirmTestTypeUrl } from "../../utils/constants";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { ArrowRightCircleFill } from "react-bootstrap-icons";
import { getTestTypeValueFromUrl, TEST_TYPE_TO_NAME } from "../../utils";
import { typeConfirmationSchema } from "../../stories/Forms/validationSchema";
import StepProgressBar from "../../stories/ProgressBars/ProgressBar";

let newData;
let bid;

/**
 * Component to confirm the test type selected by the user.
 * Handles form submission, API calls, and navigation based on the user's selection.
 */

const ConfirmTestType = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const { callApi, resultPost, serverError } = useApis();
  const { test_type } = useParams();
  const edit = location.search.includes("edit=true");
  if (edit) {
    bid = location.search?.split('?')[2]?.split('=')[1];
  }
  const [formData, setFormData] = useState({ test_type: getTestTypeValueFromUrl(test_type) });

  useEffect(() => {
    localStorage.setItem("verifyCard", false);
    localStorage.setItem("isLoggedIn", true);
  }, []);

  // Updates the form data based on the test_type
  useEffect(() => {
    if (test_type) {
      setFormData({ test_type: getTestTypeValueFromUrl(test_type) });
    }
  }, [test_type]);

  // Handles API response and navigation
  useEffect(() => {
    if (resultPost && resultPost.status === "success") {
      localStorage.setItem(
        "test_type",
        newData?.test_type ||
        formData?.test_type ||
        getTestTypeValueFromUrl(test_type)
      );
      auth?.showToast(
        "Test type confirmation",
        "Test type confirmed!",
        "../assets/mhc.png",
        <ArrowRightCircleFill />
      );

      // Navigates based on whether the form is in edit mode
      if (edit) {
        navigate(`/bloods/boots/success-page/${newData?.test_type}/${bid}`);
      } else {
        navigate(
          `/bloods/boots/${newData?.test_type ||
          formData?.test_type}/booking/confirm-details/${resultPost.bid}`
        );
      }
    }
  }, [resultPost, navigate]);

  useEffect(() => {
    if (serverError) {
      auth?.showToast(
        "Error",
        typeof serverError === "string" ? serverError : JSON.stringify(serverError),
        "../assets/mhc.png",
        <ArrowRightCircleFill />
      );

    }
  }, [serverError])

  // Handles form submission
  const handleSubmit = async data => {

    // Update formData correctly as an object
    setFormData({ test_type: data.test_type || formData.test_type || getTestTypeValueFromUrl(test_type) });

    if (!edit) {
      // If not editing, uses formData or test_type value from URL
      const test_type_data = data.test_type
        ? data
        : formData || getTestTypeValueFromUrl(test_type);
      newData = {
        ...test_type_data
      };
    } else {
      // If editing, includes additional bid and edit flags
      newData = {
        bid: bid,
        test_type: data.test_type
          ? data?.test_type
          : formData?.test_type || getTestTypeValueFromUrl(test_type),
        edit: true
      };
    }
    // Prepares payload and make API call
    const payload = {
      ...newData
    };
    await callApi(payload, confirmTestTypeUrl, "POST");
  };


  return (
    <div className="confirm-test-form">
      <div className="row justify-content-center dashboard-page confirm-test-modal">
        <div className="col-md-12">
          {
            <StepProgressBar
              steps={5}
              currentStep={1}
              completedSteps={0}
              isCompleted={0}
              is_assessment_completed={false}
            />
          }
          <div className="phlebotomist-booking">
            <span>
              Pre-Appointment Registration & Health Assessment
            </span><br/>
            <h6>
              Boots In-store Wellness Testing Service
            </h6>
            <p className="ageo-medium">
              We ask you to complete a short health assessment before your appointment to finalise your registration for your Boots in-store service.
            </p>
            <p className="ageo-regular text-muted mb-4 pb-1">You’re booked for:<br/> <b className="phlebo-test-type">{TEST_TYPE_TO_NAME[getTestTypeValueFromUrl(test_type)]}</b></p>
            <p className="ageo-regular text-muted">
              If this is not the testing service you have booked, please check
              your appointment booking email and use the <b className="text-teal">registration link
              provided.</b> It’s important that the service shown here matches your
              booking. Payment for your service will be taken on the day of your
              appointment.
            </p>
          <p className="ageo-regular text-muted last-phlebo-p">If you encounter any issues, please contact our customer care team at <a href="mailto:care@myhealthchecked.com" className="text-teal">care@myhealthchecked.com.</a></p>
          </div>
          <p className="server-error">
            {location?.pathname.includes("unknown")
              ? "There seems to be some issue wih the test type, you can select the test-type you had selected during appointment registration"
              : ""}
          </p>
          <DynamicForm
            dataTestid={"confirm-form"}
            fields={testTypeFields}
            initialValues={formData}
            onSubmit={handleSubmit}
            validationSchema={typeConfirmationSchema}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmTestType;
